import { get, del } from "@/shared/utils/fetchApi";

export interface AuthorizedApp {
  id: string;
  token_prefix: string;
  client_name: string;
  client_uri: string | null;
  logo_uri: string | null;
  scope: string;
  user_id: string;
  authorized_by_name: string | null;
  authorized_by_email: string | null;
  created_at: string;
  last_used_at: string | null;
  usage_count: number;
  expires_at: string;
}

interface AuthorizedAppsResponse {
  data: AuthorizedApp[];
}

export class AuthorizedAppsService {
  static async listByWorkspace(workspaceId: string): Promise<AuthorizedApp[]> {
    const path = `/oauth/products/${workspaceId}/authorized-apps`;
    const result = await get<AuthorizedAppsResponse>(path);
    return result.data;
  }

  static async revoke(workspaceId: string, id: string): Promise<void> {
    const path = `/oauth/products/${workspaceId}/authorized-apps/${encodeURIComponent(id)}`;

    await del(path);
  }
}
